<template>
  <div class="homeview" v-wechat-title="$t($route.meta.title) + ' - ' + $t('app.name')">
 
    <Marqueex v-if="shownotice" :dataList="dataList" @closenotice="shownotice = false"></Marqueex>
    <NavHome class="homeNav" ref="homeNav" :from="'home'" v-once/>
    <Banner></Banner>
    <S1 :class="$style.componentMain"></S1>
    <News :dataItems="news" :class="$style.componentMain"/>
    <S2 :class="$style.componentMain"></S2>
    <!-- <YSlider :class="$style.slider"/>
    <CompetitiveAdvantage :class="$style.componentMain" v-once/>
    <Culture :class="$style.componentMain"/>
    <About :class="$style.componentMain"/> -->
    <Footer1></Footer1>
    <!-- <Map :class="$style.componentMain"/> -->
    <!-- <Video :class="$style.componentMain"/> -->
    <!-- <Team :class="$style.componentMain"/> -->
    <!-- <Industry :class="$style.componentMain"/> -->
    <!-- <News :dataItems="news" :class="$style.componentMain"/> -->
    <!-- <img src="~@/assets/images/home/footer.jpg" class="footerimg"> -->
  </div>
</template>

<script>
import NavHome from './layout/NavHome'
import Banner from './home/Banner'
import S1 from './home/S1'
import S2 from './home/S2'
import Marqueex from './home/Marqueex' 
// import YSlider from './home/Slider'
// import CompetitiveAdvantage from './home/CompetitiveAdvantage'
// import LawRules from './home/LawRules'
// import NewsActivity from './home/NewsActivity'
// import Footer from './layout/Footer'
// import Map from './home/Map'
// import Video from './home/Video'
// import Team from './home/Team'
// import Industry from './home/Industry'
import News from './home/News'
// import Culture from './home/Culture'
// import About from './home/About'
import Footer1 from './layout/Footer1'

export default {
  name: 'Home',
  props: {
    accountActivationCode: {
      type: String,
      default: '',
      required: false
    },
    rstName: {
      type: String,
      default: '',
      required: false
    },
    rstCode: {
      type: String,
      default: '',
      required: false
    }
  },
  // components: { NavHome, YSlider, CompetitiveAdvantage, Map, Video, Team, Industry, News, LawRules, NewsActivity, Culture, About, Footer, Footer1 },
  components: { NavHome, Banner, S1, News, S2, Footer1, Marqueex },
  data () {
    return {
      shownotice:true,
      news: [],
      laws: [],
      dataList:[]
    }
  },
  computed: {
    optionLeft() {
    return {
        step:0.8,
        direction: 2,// 0向下 1向上 2向左 3向右
        // limitMoveNum: this.dataList.length,// 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true,
        openTouch: false,
    };
    },
  },
  created () {
    this.$api.getIndex({
      success: (response) => {
        if (response.data.code === 200) {
          this.news = response.data.data.news || []
          this.laws = response.data.data.laws || []
        }
      },
      error: () => {}
    })

    this.$api.noticelist({
      success: (response) => {
        if (response.data.code === 200) {
          this.dataList = response.data.data || []
         
      
        }
      },
      error: () => {}
    })
  },
 
  mounted () {
    this.$nextTick(() => {
      if (this.$route.query.backurl) {
        this.$store.commit('account/setUserInfo', null)
        this.$store.commit('account/setModalState', true)
      }
      this.accountActivationCode = this._.trim(this.accountActivationCode || '')
      if (this.accountActivationCode) {
        this.$api.activationAccount(this.accountActivationCode, {
          success: (response) => {
            if (response.data.code === 200) {
              this.$Message.success({content: this.$t('account.reg.activitySuccess'), closable: true})
            } else if (response.data.code === 200921) {
              this.$Message.error({content: this.$t('account.reg.emailLinkInvalid'), closable: true})
            } else {
              this.$Message.error({content: this.$t('account.reg.activityFail'), closable: true})
            }
          },
          error: () => {
            this.$Message.error({content: this.$t('common.tryAgain'), closable: true})
          }
        })
      }
    })
  }
}
</script>

<style scoped>
.homeview{
  position: relative;
}
.homeNav{
  position: absolute;
  z-index: 101;

  width: 100%;
}
.footerimg{
  display: block;
  width: 100%;
}
</style>
<style module>
  .slider{
    width: 100%;
    height: 100vh;
    position: relative;
    z-index: 100;
  }
  .componentMain{
    padding: 60px 0;
    background-color: #fff;
  }
  .componentMain div[class="wrap"]{
    width:1400px;
    margin: 0 auto;
   
  }
  .componentMain header{
    margin-bottom: 30px;
    font-size: 2.6rem;
    color: #0174ad;
    font-weight: bold;
  }
  .componentMain header span{
    position: relative;
  }
  .componentMain header span:before,
  .componentMain header span:after{
    content: "";
    position: absolute;
    height: 2px;
    background-color: #0174ad;
    width: 36px;
    top: 50%;
    transform: translateY(-50%);
  }
  .componentMain header span:before{
    left: -56px;
  }
  .componentMain header span:after{
    right: -56px;
  }
  .componentMain div[class~="item"] p[class~="title"],
  .componentMain li[class~="item"] p[class~="title"]{
    color: var(--homeTitleColor);
  }
  .componentMain div[class~="item"] p[class~="desc"],
  .componentMain li[class~="item"] p[class~="desc"]{
    color: #666;
  }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue